export var FeaturePosition;
(function (FeaturePosition) {
    FeaturePosition["statisticCard"] = "feature_statisticCard";
    FeaturePosition["pie"] = "feature_pie";
    FeaturePosition["line"] = "feature_line";
    FeaturePosition["column"] = "feature_column";
    FeaturePosition["dynamic"] = "feature_dynamic";
})(FeaturePosition || (FeaturePosition = {}));
